import React, { Component } from 'react'
import update from 'react/lib/update';
import PropTypes from 'prop-types'
import Radium from 'radium';
import Row from './table/row'
import Cell from './table/cellTextarea'
import Header from './table/header'
import { semanticColors } from '../../../../Globals/styles';

const propTypes = {}

const defaultProps = {}

class Activity extends Component {
    constructor(props) {
        super(props)
        this.state = {
            width: [
                '5%',
                '55%',
                '20%',
                '10%',
                '10%',
            ]
        }
    }
    shouldComponentUpdate(nextProps) {
        if (this.props.activitiesKey === nextProps.activitiesKey) { return false }
        return true
    }
    renderHeader = () => {
        return (
            <Row
            >
                <Header
                    content={'Pos.'}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Art'}
                    style={{ width: this.state.width[1] }}
                />
                <Header
                    content={'Timer'}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Pris'}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Sum'}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        textAlign: 'right',
                        paddingRight: 5,
                    }}
                />
            </Row>
        )
    }
    updateFunction = (key, value, obj, index) => {
        obj[key] = value
        this.props.update(index, obj)
    }

    parseAndCalcSum(one, two) {
        return (parseFloat(one.toString().replace(',', '.')) * parseFloat(two.toString().replace(',', '.')))
    }

    updateChild(key, value, index, r, parentIndex) {
        let newTotal = 0
        r.subActivities.forEach((s, il) => {
            if (il === index) {
                let v = value
                if (key === 'hours') {
                    newTotal += parseFloat(value.replace(',', '.'))
                    v = value.replace('.', ',')
                } else {
                    newTotal += parseFloat(s.hours.toString().replace(',', '.'))
                }
                s[key] = v
            }
            else {
                newTotal += parseFloat(s.hours.toString().replace(',', '.'))
            }
        })
        r.totalHours = newTotal
        this.props.update(parentIndex, r)
    }

    renderContent = (r, background, index) => {
        return (
            <Row
                key={r.activityGroupName}
                style={
                    !index === 0 ? { paddingTop: 2 } : null}
            >
                <Cell
                    content={r.pos}
                    onChange={(value) => this.updateFunction('pos', value, r, index)}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('display', value, r, index)}
                    content={r.display}
                    style={{ width: this.state.width[1] }}
                    inputStyle={{
                        backgroundColor: background,
                        fontWeight: 600,
                    }}
                />
                <Cell
                    content={r.totalHours.toString().replace('.', ',')}
                    style={{ width: this.state.width[2] }}
                    onChange={(value) => this.updateFunction('totalHours', value, r, index)}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                        fontWeight: 600
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('price', value, r, index)}
                    content={r.price ? r.price.toString().replace('.', ',') : ''}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    key={Math.random()}
                    content={(Math.round(this.parseAndCalcSum(r.totalHours, r.price ? r.price : 0) * 100) / 100).toString().replace('.', ',')}
                    style={{ width: this.state.width[4] }}
                    readOnly
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'right',
                        paddingRight: 5,
                    }}
                />
            </Row>
        )
    }

    renderChildContent = (c, background, index, r, parentIndex) => {
        return (
            <Row
                key={r.activityGroupName + index}
            >
                <Cell
                    content={c.pos}
                    onChange={(value) => { this.updateChild('pos', value, index, r, parentIndex) }}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => { this.updateChild('name', value, index, r, parentIndex) }}
                    content={c.name}
                    style={{ width: this.state.width[1] }}
                    inputStyle={{
                        backgroundColor: background,
                        paddingLeft: 15,
                    }}
                />
                <Cell
                    onChange={(value) => { this.updateChild('hours', value, index, r, parentIndex) }}
                    content={c.hours ? c.hours.toString().replace('.', ',') : ''}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',

                    }}
                />
                <Cell
                    content={''}
                    readOnly
                    style={{ width: this.state.width[3] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    content={''}
                    readOnly
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'right',
                        paddingRight: 5,
                    }}
                />
            </Row>
        )
    }
    render() {
        let rac = []
        let total = 0
        this.props.rows.forEach((r, index) => {
            let background = index % 2 == 0 ? semanticColors.mainBackground2 : semanticColors.primaryLight
            rac.push(this.renderContent(r, background, index))
            r.subActivities.forEach((c, i) => {
                rac.push(this.renderChildContent(c, background, i, r, index))
            })

            total += this.parseAndCalcSum(r.totalHours, (r.price ? r.price : 0))
        })

        return (
            <div style={[{ width: '100%' }]}>
                {this.renderHeader()}
                {rac}
                <div style={{ float: 'right', padding: 5, borderBottom: '1px solid ' + semanticColors.primaryLight }}>
                    <div style={{ fontWeight: 600 }}>
                        I alt: {(Math.round(total * 100) / 100).toString().replace('.', ',')}
                    </div>
                </div>
            </div>
        )
    }
}

const styles = {
    flexify: {
        display: 'flex',
        flexDirection: 'row',
    },
    column: {
        flexGrow: 0,
        flexShrink: 0,
        verticalAlign: 'top',
    }
}

Activity.propTypes = propTypes

Activity.defaultProps = defaultProps

export default Radium(Activity)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Tilbud/spreadsheets/activity.js